import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Menu } from 'floating-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HoverMenu',
  props: {
  shown: Boolean
},
  emits: ["dropdown:toggle"],
  setup(__props, { emit }: { emit: ({
  (e: 'dropdown:toggle', state: boolean): void
}), expose: any, slots: any, attrs: any }) {





function handleMouseEnter() {
  emit('dropdown:toggle', true)
}

function handleMouseLeave() {
  emit('dropdown:toggle', false)
}

function handleUpdate(value: boolean) {
  emit('dropdown:toggle', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), _mergeProps(_ctx.$attrs, {
    placement: "top",
    "popper-class": "v-popper__navigation",
    delay: 200,
    distance: 8,
    shown: __props.shown,
    triggers: ['click', 'hover', 'focus'],
    "onUpdate:shown": handleUpdate
  }), {
    popper: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 32)
    ]),
    _: 3
  }, 16, ["shown"]))
}
}

})